import React from 'react';

export const DKPartNumberCellRenderer: React.FC = (props: any) => {
  const { data } = props;

  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'first-row') {
    return null;
  }

  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'second-row') {
    return null;
  }

  return (
    <div
      id="DK-part-number"
      style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.8' }}
    >
      {data.productVariations &&
        data.productVariations.map((item: any, index: number) => {
          return <span key={index}>{item?.digiKeyProductNumber}</span>;
        })}
    </div>
  );
};
